const createAction = name => `@@legalConsentOptions/${name}`;
export const REQUEST_DEFAULT_LEGAL_CONSENT_OPTION = createAction('REQUEST_DEFAULT_LEGAL_CONSENT_OPTION');
export const RECEIVE_DEFAULT_LEGAL_CONSENT_OPTION = createAction('RECEIVE_DEFAULT_LEGAL_CONSENT_OPTION');
export const FAIL_DEFAULT_LEGAL_CONSENT_OPTION = createAction('FAIL_DEFAULT_LEGAL_CONSENT_OPTION');
export const requestDefaultLegalConsentOption = () => ({
  type: REQUEST_DEFAULT_LEGAL_CONSENT_OPTION
});
export const receiveDefaultLegalConsentOption = legalConsent => ({
  type: RECEIVE_DEFAULT_LEGAL_CONSENT_OPTION,
  legalConsent
});
export const failDefaultLegalConsentOption = () => ({
  type: FAIL_DEFAULT_LEGAL_CONSENT_OPTION
});